"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdNumberValidator = void 0;
var class_validator_1 = require("class-validator");
var IdNumberValidator = exports.IdNumberValidator = /** @class */ (function () {
    function IdNumberValidator() {
    }
    IdNumberValidator.prototype.validate = function (idNumber) {
        var _a;
        var regex = /\d{7,8}-(\d|K)/;
        if (!regex.test(idNumber)) {
            return false;
        }
        var numberAsString = (_a = idNumber.split('-'), _a[0]), digit = _a[1];
        var idNumberDigits = parseInt(numberAsString, 10);
        var m = 0;
        var s = 1;
        while (idNumberDigits > 0) {
            s = (s + ((idNumberDigits % 10) * (9 - (m % 6)))) % 11;
            idNumberDigits = Math.floor(idNumberDigits / 10);
            m += 1;
        }
        var checkDigit = (s > 0) ? String((s - 1)) : 'K';
        return (checkDigit === digit);
    };
    IdNumberValidator.prototype.defaultMessage = function () {
        return '$property must be a valid rut using the format 12345678-5 (or uppercase K) rut';
    };
    IdNumberValidator = __decorate([
        (0, class_validator_1.ValidatorConstraint)({ name: 'idNumber', async: false })
    ], IdNumberValidator);
    return IdNumberValidator;
}());
